import ExternalLogger from "../../ExternalLogger";

const errorController = function errorController(
    $injector,
    $rootScope,
    $scope,
    $stateParams,
    $state,
    $window,
    LogoutService,
    MenuNavigationFactory
) {
    const logger = ExternalLogger.getInstance("ErrorController");
    logger.debug("ErrorCode: ", $stateParams.errorCode);
    const errorCodeTranslationKey = $stateParams.errorCode;
    const changeTitle = $stateParams.changeTitle;
    const enableCustomError = $stateParams.enableCustomError;
    const customTitleTranslationKey = $stateParams.customTitleKey;
    const customMessageTranslationKey = $stateParams.customMessageKey;

    if (errorCodeTranslationKey === "I") {
        $scope.errorCodeMsg = "error." + errorCodeTranslationKey;
    } else if (errorCodeTranslationKey === "44404") {
        LogoutService.logOutServices.query(function (data) {
            LogoutService.logOutPartAuth.query().$promise.then(
                {},
                function (data) {
                    logger.debug("part auth session invalidated");
                    $cookies.remove("JSESSIONID", { path: "/participant-web-services" });
                    $cookies.remove("JSESSIONID", { path: "/participant-authentication" });
                    $cookies.remove("site_tok", { path: "/participant" });
                    $cookies.remove("site_tok", { path: "/" });
                    $cookies.remove("X-CSRF-TOKEN", { path: "/" });
                    $cookies.remove("PM-INDID-TOKEN", { path: "/" });
                    $cookies.remove("PM-PLAN-TOKEN", { path: "/" });
                    $cookies.remove("PM-ACCU-TOKEN", { path: "/" });
                },
                function (error) {
                    $cookies.remove("JSESSIONID", { path: "/participant-web-services" });
                    $cookies.remove("JSESSIONID", { path: "/participant-authentication" });
                    $cookies.remove("site_tok", { path: "/participant" });
                    $cookies.remove("site_tok", { path: "/" });
                    $cookies.remove("X-CSRF-TOKEN", { path: "/" });
                    $cookies.remove("PM-INDID-TOKEN", { path: "/" });
                    $cookies.remove("PM-PLAN-TOKEN", { path: "/" });
                    $cookies.remove("PM-ACCU-TOKEN", { path: "/" });
                }
            );
            MenuNavigationFactory.getAccu.query({}, function (code) {
                //using image rather than $http due to redirects.
                const tmpImg = new Image();
                if (code[0] === $scope.accu) {
                    tmpImg.src = __iframeUrl__ + "/logoutNextgen.do?accu=" + $scope.accu;
                } else {
                    tmpImg.src =
                        __iframeUrl__ +
                        "/logoutNextgen.do?accu=" +
                        code[0] +
                        "&overrideAccu=" +
                        $scope.accu;
                }
                $rootScope.$emit("loginAuthStatusVerified", $scope.authenticationStatus);
                //redirect to legacy login page when loaded from legacy iframe(for AF withdrawal iframe).
                if ($rootScope.iframe) {
                    $window.top.location.href =
                        window.location.origin + "/login.do?accu=" + code[0];
                }
            });
        });
    } else {
        $scope.errorCodeMsg = "error.unauthorized";
    }

    if (changeTitle === "true") {
        $scope.headingTitle = "error.notAllMoneyTypeGroupingsGuidanceFlowTitle";
    } else {
        $scope.headingTitle = "error.headingTitle";
    }

    if (enableCustomError && enableCustomError.toLowerCase() === "true") {
        $scope.customHeadingTitle = customTitleTranslationKey;
        $scope.customMessage = customMessageTranslationKey;
    }

    $scope.myInvestmentsLinkClick = function () {
        const accountService = $injector.get("accountService");

        $state.go("accountDetails.investments.investmentOverview", {
            individualId: accountService.getActiveGroupAccount().individualId,
            groupId: accountService.getActiveGroupAccount().groupId
        });
    };

    $scope.loginLinkClick = function () {
        $state.go("home", {});
    };
}; //End of closure

errorController.$inject = [
    "$injector",
    "$rootScope",
    "$scope",
    "$stateParams",
    "$state",
    "$window",
    "LogoutService",
    "MenuNavigationFactory"
];
export default errorController;
